import BaseUtils from './base';

class I18n extends BaseUtils {
  t(code, args) {
    return this.vue().$i18n.t(this.code(code), args);
  }

  te(code) {
    return this.vue().$i18n.te(this.code(code));
  }

  tc(code, count, args) {
    return this.vue().$i18n.tc(this.code(code), count, args);
  }

  code(code) {
    return code.replace(/\//g, '');
  }

  localeWithDash() {
    return this.vue().$i18n.locale.replace(/_/g, '-');
  }
}

export default new I18n();
